<span class="avatar body-sm-semibold">{{ initials() }}</span>
